<template>
	<div class="pageContainer">
		<PageHeader
			addClass="is-dxai"
			:image="require('../assets/dxai/title_pc.svg')"
			:imageSp="require('../assets/dxai/title_sp.svg')"
			alt="企業のデジタル変革、事業創発を伴走型で支援する。"
			intro="データが新しい資産として注目され、<br class='over_display'>デジタル化の急速な進展と新たなテクノロジが企業のIT環境を劇的に変える中で、<br class='over_display'>様々な企業がDXによるビジネス成長を戦略に掲げています。<br>DX・AIソリューション領域は、このまさに「旬」ともいえるお客様の経営課題に対して、<br class='over_display'>組織ケイパビリティ、プロセス改善、先進テクノロジ活用の観点で進むべき道を共有し、<br class='over_display'>お客様が継続的にビジネス成長を果たせるように伴走型の支援を行います。"
		/>
		<BgTitleBox
			:bgPc="require('../assets/dxai/bgBox_pc.jpg')"
			:bgSp="require('../assets/dxai/bgBox_sp.jpg')"
			title="DX・AIソリューション領域の概要"
		/>
		<DxAiArticle />
	</div>
</template>

<script>
import PageHeader from '@/components/mainpage/PageHeader.vue';
import BgTitleBox from '@/components/common/BgTitleBox.vue';
import DxAiArticle from '../components/mainpage/DxAiArticle.vue';
export default {
	name: 'dx-ai',
	components: {
		PageHeader,
		BgTitleBox,
		DxAiArticle,
	},
};
</script>

<style lang="scss" scoped>
.pageContainer {
	position: relative;
	overflow: hidden;
	width: 100%;
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 100px;
	}
	&::after {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		bottom: 0;
		left: 0;
		transform: skewY(-18deg);
		transform-origin: left top;
		z-index: -1;
		@media print, screen and (min-width: 1161px) {
			bottom: 0px;
		}
	}
}
</style>
